// eslint-disable-next-line simple-import-sort/imports
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import 'bootstrapDesignSystem';
import { bootstrapApi } from 'bootstrapApi';
import { bootstrapGtm } from 'bootstrapGtm';
import { router } from './router';

bootstrapGtm();
bootstrapApi();

const rootElement = document.getElementById('app')!;
const root = createRoot(rootElement);

root.render(<RouterProvider router={router} />);
